import Layout from '@/layout'

export default [
	{
		order: 4,
		path: '/communication-model-manage',
		component: Layout,
		meta: {
			title: '通讯模组管理',
			subtitle: '模组',
			icon: 'icon-juminbiao',
		},
		redirect: '/communication-model-manage/manage',
		children: [
			{
				path: 'om-platform-information',
				name: 'omPlatformInformation',
				meta: {
					title: '运营商平台信息',
					keepAlive: true,
					permissions: ['monitor:imei:platform:product:select'],
				},
				component: () => import('@/pages/communication-model-manage/om-platform-information/index.vue'),
			},
			{
				path: 'om-platform-information/details',
				name: 'omPlatformInformationDetails',
				meta: {
					title: '运营商平台详情',
					hidden: true,
					keepAlive: false,
				},
				component: () => import('@/pages/communication-model-manage/om-platform-information/Details.vue'),
			},
			{
				path: 'device-group',
				name: 'deviceGroup',
				meta: {
					title: '设备组管理',
					keepAlive: true,
					permissions: ['monitor:imei:group:select'],
				},
				component: () => import('@/pages/communication-model-manage/device-group/index.vue'),
			},
			{
				path: 'device-group/details',
				name: 'deviceGroupDetails',
				meta: {
					title: '设备组详情',
					hidden: true,
					keepAlive: false,
				},
				component: () => import('@/pages/communication-model-manage/device-group/Details.vue'),
			},
			{
				path: 'module-manage',
				name: 'moduleManage',
				meta: {
					title: '模组管理',
					keepAlive: true,
					permissions: ['monitor:imei:device:select'],
				},
				component: () => import('@/pages/communication-model-manage/module-manage/index.vue'),
			},
			{
				path: 'module-manage/details',
				name: 'moduleManageDetails',
				meta: {
					title: '模组详情',
					hidden: true,
					keepAlive: false,
				},
				component: () => import('@/pages/communication-model-manage/module-manage/Details.vue'),
			},
			{
				path: 'batch-task',
				name: 'batchTask',
				meta: {
					title: '批量任务',
					keepAlive: true,
					permissions: ['monitor:imei:batch:select'],
				},
				component: () => import('@/pages/communication-model-manage/batch-task/index.vue'),
			},
			{
				path: 'batch-task-details',
				name: 'batchTaskDetails',
				meta: {
					title: '批量任务详情',
					keepAlive: false,
					hidden: true,
				},
				component: () => import('@/pages/communication-model-manage/batch-task/Details.vue'),
			},
		],
	},
]
